import React from 'react'
import "./Post.css"
import {Avatar} from "@material-ui/core";
import ChatIcon from "@material-ui/icons/Chat";
import FavoriteIcon from '@material-ui/icons/Favorite';
import CommentIcon from '@material-ui/icons/Comment';
import SendIcon from '@material-ui/icons/Send';
import BookmarkOutlinedIcon from '@material-ui/icons/BookmarkOutlined';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import SentimentSatisfiedOutlinedIcon from '@material-ui/icons/SentimentSatisfiedOutlined';

function Post({profilePic, image, title}) {
    return (
        <div className="post">

            <div className="nameTag">
            <Avatar src={profilePic}/>
            <h3>{title}</h3>
            <div className="load">
            <MoreHorizOutlinedIcon/>
            </div>
            </div>

            <img src={image} alt="Taran"/>
            
            <div class="tools">
            <div className="tool">
                <FavoriteIcon/></div>
                <div className="tool">
                <CommentIcon/></div>
                <div className="tool">
                <SendIcon/></div>
                <div className="saved">
                <BookmarkOutlinedIcon/>
                </div>
                </div>

                <div className="comment">
                    <div class="emoji">
                <SentimentSatisfiedOutlinedIcon fontSize="medium"/>
                </div>
                <div className="commentS">
                <input type="text" size="55"placeholder="Add a comment..."/>
                </div>
                <a href="#" className="posst">Post</a>
                    </div>


        </div>
        
    )
    

    
}




export default Post
